export const getImageBrightness = (imageUrl) => {
  return new Promise((resolve) => {
    const img = new Image()

    img.crossOrigin = 'anonymous'

    img.onload = () => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      canvas.width = img.width
      canvas.height = img.height

      ctx.drawImage(img, 0, 0)

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
      const data = imageData.data

      let totalBrightness = 0
      let pixelCount = 0

      for (let i = 0; i < data.length; i += 40) {
        const r = data[i]
        const g = data[i + 1]
        const b = data[i + 2]
        const brightness = (r * 0.299 + g * 0.587 + b * 0.114)

        totalBrightness += brightness
        pixelCount++
      }

      const averageBrightness = totalBrightness / pixelCount
      const isDark = averageBrightness < 150

      resolve(isDark ? 'dark' : 'light')
    }

    img.onerror = () => {
      resolve('light')
    }

    img.src = imageUrl
  })
}
